export const reviews = [
  {
    id: 1,
    name: "Ashish",
    rating: 4,
    text: "Planning events can be stressful, but working with PartyNestt was a dream. They handled everything from design ideas to setup without me lifting a finger. The balloon centerpiece for my baby shower was absolutely gorgeous, and I received so many compliments. They truly made the day memorable!"
  },
  {
    id: 2,
    name: "Taniya Kaur",
    rating: 4,
    text: "Planning events can be stressful, but working with PartyNestt was a dream. They handled everything from design ideas to setup without me lifting a finger. The balloon centerpiece for my baby shower was absolutely gorgeous, and I received so many compliments. They truly made the day memorable!"
  },
  {
    id: 3,
    name: "Riya sharma",
    rating: 3,
    text: "I booked decoration for my daughter's 5th birthday, and the balloon decorations were breathtaking! The pastel arch they created made the perfect backdrop for photos, and the attention to detail was incredible. The kids loved it, and so did the adults."
  }
];

export const stats = [
  {
    id: 1,
    icon: "⭐",
    value: "1M+",
    label: "Happy Customers"
  },
  {
    id: 2,
    icon: "📍",
    value: "19K+",
    label: "Followers"
  },
  {
    id: 3,
    icon: "🏆",
    value: "",
    label: "Party Expert"
  },
  {
    id: 4,
    icon: "🛡️",
    value: "",
    label: "Safe & Secure Payments"
  }
];

